import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import * as CompanyActions from './company.actions';
import { Connect } from '../../classes/connect';
import { ConnectServerService } from '../../services/connect-server.service';
import { CompanyDefaultValues } from '../../interfaces/company-default-values';

@Injectable()
export class CompanyEffects {
  loadCompany$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CompanyActions.loadCompany),
      mergeMap(() =>
        this.connectServerService.getRequestLara<CompanyDefaultValues>(Connect.urlServerLaraApi, 'company/defaultCompanyValues', {})
        .pipe(
          map(company => CompanyActions.loadCompanySuccess({ company })),
          catchError(error => of(CompanyActions.loadCompanyFailure({ error })))
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private connectServerService: ConnectServerService
  ) {}
}
